import { Box, Paper, PaperProps } from '@material-ui/core'
import cls from 'classnames'

import { useStyles } from './styles'

interface CardProps extends PaperProps {
  className?: string
  contentClassName?: string
}
export default function Card({
  children,
  className,
  contentClassName,
}: CardProps) {
  const classes = useStyles()

  return (
    <Paper
      data-testid='card'
      elevation={2}
      className={cls(className, classes.main)}
    >
      <Box data-testid='box' className={cls(contentClassName, classes.content)}>
        {children}
      </Box>
    </Paper>
  )
}
